var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('JobsEditModal',{attrs:{"name":_vm.modalName,"persistent":"","title":"Work Preferences"},on:{"save":_vm.handleSave}},[_c('JobsDesiredCriteriaModalForm',_vm._b({ref:"form",on:{"upsert":_vm.handleUpsert}},'JobsDesiredCriteriaModalForm',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }